module.exports = __webpack_public_path__ + "img/Indonesia-07.073dd574.jpg";